// eslint-disable-next-line no-shadow
export enum RolesEnum {
  VivaLNKAdmin = 'VivaLNK Admin',
  ProgramManager = 'Program Manager',
  TenantAdmin = 'Tenant Admin',
  SuperAdmin = 'Super Admin',
  SiteAdmin = 'Site Admin',
  Admin = 'Site Admin',
  Technician = 'Technician',
  Physician = 'Physician',
  Researcher = 'Researcher',
  EnrollmentCoordinator = 'Enrollment Coordinator',
  ClinicalTrialCoordinator = 'Clinical Trial Coordinator',
  Analyst = 'Analyst',
}
// eslint-disable-next-line no-shadow
export enum RolesCodeEnum {
  VivaLNKAdmin = 'vivalink_super',
  EnrollmentCoordinator = 'enrollment_coordinator',
  ProgramManager = 'program_manager',
  TenantAdmin = 'tenant_admin',
  SuperAdmin = 'super_admin',
  Admin = 'admin',
  Technician = 'technician',
  Physician = 'physician',
  Researcher = 'researcher',
  ClinicalTrialCoordinator = 'clinical_trial_coordinator',
  Analyst = 'analyst',
}

export type RoleName = keyof typeof RolesEnum;

export interface Role {
  id: string;
  name: string;
  key?: RoleName;
  permissions?: string[];
}

export interface RawRole {
  id: string;
  name: string;
  key?: RoleName;
  permissions?: string[];
}

export class RoleModel implements Role {
  id: string;

  name: string;

  key?: RoleName;

  constructor(data: RawRole) {
    this.id = data.id;
    this.name = data.name;
    this.key = data?.key || (data.name.replace(' ', '') as RoleName);
  }
}
